import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Dashboard from "../side_bar/dashboard";
import Users from "../side_bar/users";
import Products from "../side_bar/content";
import Settings from "../side_bar/settings";
import Subscriptions from "../side_bar/subscriptions";
import Competitions from "../side_bar/competitions";
import Lifestyle from "../side_bar/lifestyle_admin";
import Magazine from "../side_bar/magazine";
import MusicAdminPage from "../side_bar/music";
import VotePackages from "../side_bar/vote_packages";

/* ---------------------------------------------------------------------------
   Icon set — inline SVGs keyed by name so nav items stay declarative.
--------------------------------------------------------------------------- */
const ICONS = {
  dashboard: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"
    />
  ),
  users: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
    />
  ),
  content: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
    />
  ),
  subscriptions: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  ),
  votes: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  ),
  competitions: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.515M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0"
    />
  ),
  lifestyle: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
    />
  ),
  music: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z"
    />
  ),
  magazine: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
    />
  ),
  logout: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
    />
  ),
  chevron: (
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
  ),
};

function NavIcon({ name, className = "w-[18px] h-[18px]" }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      {ICONS[name]}
    </svg>
  );
}

/* ---------------------------------------------------------------------------
   Navigation model — one declarative structure drives the sidebar, the
   breadcrumb and the content router.
--------------------------------------------------------------------------- */
const NAV_SECTIONS = [
  {
    label: "Overview",
    items: [{ id: "dashboard", label: "Dashboard", icon: "dashboard" }],
  },
  {
    label: "People",
    items: [{ id: "users", label: "Users", icon: "users" }],
  },
  {
    label: "Monetisation",
    items: [
      { id: "subscriptions", label: "Subscriptions", icon: "subscriptions" },
      { id: "votes", label: "Vote Packages", icon: "votes" },
    ],
  },
  {
    label: "Content",
    items: [
      { id: "content", label: "Content", icon: "content", expandable: true },
      { id: "competitions", label: "Competitions", icon: "competitions" },
      { id: "lifestyle", label: "Lifestyle", icon: "lifestyle" },
      { id: "music", label: "Music", icon: "music" },
      { id: "magazine", label: "Magazine", icon: "magazine" },
    ],
  },
];

const CONTENT_SUBTABS = [
  { id: "news", label: "News" },
  { id: "sports", label: "Sports" },
  { id: "gameshows", label: "Game Shows" },
  { id: "awards", label: "Awards" },
];

const TAB_TITLES = {
  dashboard: "Dashboard",
  users: "Users",
  content: "Content",
  subscriptions: "Subscriptions",
  votes: "Vote Packages",
  competitions: "Competitions",
  lifestyle: "Lifestyle",
  music: "Music",
  magazine: "Magazine",
  settings: "Settings",
};

const getDashboardView = (search) => {
  const params = new URLSearchParams(search);
  const requestedTab = params.get("tab");
  const activeTab = Object.prototype.hasOwnProperty.call(TAB_TITLES, requestedTab)
    ? requestedTab
    : "dashboard";
  const requestedContent = params.get("content");
  const selectedContent = CONTENT_SUBTABS.some((item) => item.id === requestedContent)
    ? requestedContent
    : null;

  return { activeTab, selectedContent };
};

function AdminDashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const { activeTab, selectedContent } = getDashboardView(location.search);
  const [isContentExpanded, setIsContentExpanded] = useState(
    () => activeTab === "content"
  );

  useEffect(() => {
    if (activeTab === "content") setIsContentExpanded(true);
  }, [activeTab]);

  const navigateToView = (tab, content = null) => {
    const params = new URLSearchParams({ tab });
    if (content) params.set("content", content);
    navigate({
      pathname: location.pathname,
      search: `?${params.toString()}`,
      hash: location.hash,
    });
  };

  const handleTabClick = (tab) => {
    if (tab === "content") {
      setIsContentExpanded((prev) => !prev);
      return;
    }
    navigateToView(tab);
  };

  const handleContentClick = (content) => {
    setIsContentExpanded(true);
    navigateToView("content", content);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userId");
    sessionStorage.clear();
    navigate("/login");
  };

  // Display name for the header — best-effort from the stored profile.
  const storedName =
    localStorage.getItem("userName") ||
    localStorage.getItem("username") ||
    "";
  const userInitial = (storedName || "A").trim().charAt(0).toUpperCase();

  const renderTabContent = () => {
    switch (activeTab) {
      case "dashboard":
        return <Dashboard />;
      case "users":
        return <Users />;
      case "content":
        return <Products category={selectedContent} />;
      case "subscriptions":
        return <Subscriptions />;
      case "votes":
        return <VotePackages />;
      case "competitions":
        return <Competitions />;
      case "lifestyle":
        return <Lifestyle />;
      case "music":
        return <MusicAdminPage />;
      case "magazine":
        return <Magazine />;
      case "settings":
        return <Settings />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="flex h-screen overflow-hidden bg-surface-950">
      {/* ── Sidebar ─────────────────────────────────────────────────────────── */}
      <aside className="w-[272px] shrink-0 flex flex-col bg-surface-900 border-r border-line">
        {/* Brand */}
        <div className="h-16 flex items-center gap-3 px-6 border-b border-line">
          <div className="bg-logo-192 bg-cover w-9 h-9 rounded-lg" />
          <div className="leading-tight">
            <p className="text-sm font-bold tracking-wide text-white">DESAC TV</p>
            <p className="text-[11px] uppercase tracking-[0.18em] text-gray-500">
              Admin Console
            </p>
          </div>
        </div>

        {/* Nav sections */}
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-6">
          {NAV_SECTIONS.map((section) => (
            <div key={section.label}>
              <p className="px-3 mb-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-gray-600">
                {section.label}
              </p>
              <ul className="space-y-0.5">
                {section.items.map((item) => {
                  const isActive = activeTab === item.id;
                  const isExpanded = item.expandable && isContentExpanded;
                  return (
                    <li key={item.id}>
                      <button
                        type="button"
                        onClick={() => handleTabClick(item.id)}
                        className={`w-full flex items-center justify-between rounded-lg px-3 py-2.5 text-sm font-medium transition-colors duration-150 ${
                          isActive
                            ? "bg-accent-dim text-accent-soft"
                            : "text-gray-400 hover:text-white hover:bg-surface-700"
                        }`}
                      >
                        <span className="flex items-center gap-3">
                          <NavIcon name={item.icon} />
                          {item.label}
                        </span>
                        {item.expandable && (
                          <NavIcon
                            name="chevron"
                            className={`w-3.5 h-3.5 transition-transform duration-200 ${
                              isExpanded ? "rotate-180" : ""
                            }`}
                          />
                        )}
                      </button>

                      {/* Content sub-items */}
                      {item.expandable && isExpanded && (
                        <ul className="mt-1 mb-1 ml-4 border-l border-line pl-3 space-y-0.5">
                          {CONTENT_SUBTABS.map((sub) => (
                            <li key={sub.id}>
                              <button
                                type="button"
                                onClick={() => handleContentClick(sub.id)}
                                className={`w-full rounded-md px-3 py-2 text-left text-sm transition-colors duration-150 ${
                                  activeTab === "content" && selectedContent === sub.id
                                    ? "text-accent-soft font-medium"
                                    : "text-gray-500 hover:text-gray-200"
                                }`}
                              >
                                {sub.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </nav>

        {/* Sidebar footer */}
        <div className="border-t border-line p-3">
          <button
            type="button"
            onClick={handleLogout}
            className="w-full flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-gray-400 hover:text-white hover:bg-surface-700 transition-colors duration-150"
          >
            <NavIcon name="logout" />
            Log out
          </button>
        </div>
      </aside>

      {/* ── Main column ─────────────────────────────────────────────────────── */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Header */}
        <header className="h-16 shrink-0 flex items-center justify-between px-8 bg-surface-950 border-b border-line">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-sm">
            <span className="text-gray-500">Admin</span>
            <span className="text-gray-700">/</span>
            <span className="font-semibold text-white">
              {activeTab === "content"
                ? selectedContent
                  ? `Content · ${CONTENT_SUBTABS.find((s) => s.id === selectedContent)?.label || ""}`
                  : "Content"
                : TAB_TITLES[activeTab] || "Dashboard"}
            </span>
          </div>

          {/* User chip */}
          <div className="flex items-center gap-3">
            <span className="hidden md:inline text-sm text-gray-400">
              {storedName || "Admin"}
            </span>
            <div className="w-9 h-9 rounded-full bg-surface-600 border border-line-strong flex items-center justify-center text-sm font-bold text-accent-soft">
              {userInitial}
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-5">
          <div className="mx-auto max-w-none">{renderTabContent()}</div>
        </main>
      </div>
    </div>
  );
}

export default AdminDashboard;
